import { render } from "./settings.vue?vue&type=template&id=ffd137b4&lang=pug"
import script from "./settings.vue?vue&type=script&setup=true&lang=js"
export * from "./settings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__